import './style.scss';
import { TranslationService } from '../../../../../services/translation.service';
import type { IJourney } from '../../../../../models/journey.model';
import TransportModeIcon from '../../../TransportModeIcon';
import { JourneyHelper } from '../../../../../helpers/journey.helper';
import { DateHelper } from '../../../../../helpers/date.helper';
import type { ITripLeg } from '../../../../../models/trip-leg.model';
import LineIcon from '../../../LineIcon';
import { createWhenString } from '../helpers/summary-helpers';

function Summary({ id, journey, tripLeg, onEditButtonClick }: { id: string; journey: IJourney; tripLeg: ITripLeg; onEditButtonClick?: (() => void) | undefined }) {
  return (
    <div className="trip-leg-selector-summary p-2 rounded border">
      <table className="table table-borderless table-sm">
        <caption className="visually-hidden">{TranslationService.get('customerserviceforms.triplegselectorsummarycaption')}</caption>
        <tbody>
          {journey.tripLegs?.length === 1 && (
            <tr>
              <td colSpan={2}>
                <div className="d-flex align-items-center">
                  <div className="d-inline-block flex-shrink-0">{tripLeg.serviceJourney.line && <LineIcon line={tripLeg.serviceJourney.line} />}</div>
                  {tripLeg.serviceJourney.line && <TransportModeIcon transportMode={tripLeg.serviceJourney.line.transportMode} />}
                  <span className="fw-bold">
                    {TranslationService.get('common.towards')} {tripLeg.serviceJourney.direction}
                  </span>
                </div>
              </td>
            </tr>
          )}
          {journey.tripLegs && journey.tripLegs.length > 0 && (
            <>
              <tr>
                <th scope="row">{TranslationService.get('common.from')}:</th>
                <td className="w-100">{journey.tripLegs[0].origin.stopPoint.name}</td>
              </tr>
              <tr>
                <th scope="row">{TranslationService.get('common.to')}:</th>
                <td>{journey.tripLegs[journey.tripLegs.length - 1].destination.stopPoint.name}</td>
              </tr>
            </>
          )}
          <tr>
            <th scope="row">{TranslationService.get('common.when')}:</th>
            <td>
              <span className="text-preserve-spaces">
                {createWhenString(JourneyHelper.getFirstPublicTransportLeg(journey)?.plannedDepartureTime, JourneyHelper.getLastPublicTransportLeg(journey)?.plannedArrivalTime)}
              </span>
            </td>
          </tr>
          {JourneyHelper.getFirstPublicTransportLeg(journey)?.plannedDepartureTime && JourneyHelper.getLastPublicTransportLeg(journey)?.plannedArrivalTime && (
            <tr>
              <th scope="row">{TranslationService.get('common.traveltime')}:</th>
              <td>
                {DateHelper.formatAsHoursAndMinutes(
                  DateHelper.getDurationFromDateStrings(
                    JourneyHelper.getFirstPublicTransportLeg(journey)?.plannedDepartureTime ?? '',
                    JourneyHelper.getLastPublicTransportLeg(journey)?.plannedArrivalTime ?? ''
                  )
                )}
              </td>
            </tr>
          )}
          {journey.tripLegs && journey.tripLegs.length > 1 && (
            <>
              <tr>
                <td colSpan={2}>
                  <hr className="my-2" />
                </td>
              </tr>
              <tr>
                <th colSpan={2} scope="colgroup">
                  {TranslationService.get('common.tripleg')}:
                </th>
              </tr>
              <tr>
                <td colSpan={2}>
                  <div className="d-flex align-items-center">
                    <div className="d-inline-block flex-shrink-0">{tripLeg.serviceJourney.line && <LineIcon line={tripLeg.serviceJourney.line} />}</div>
                    {tripLeg.serviceJourney.line && <TransportModeIcon transportMode={tripLeg.serviceJourney.line?.transportMode} />}
                    <span className="fw-bold">
                      {TranslationService.get('common.towards')} {tripLeg.serviceJourney.direction}
                    </span>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">{TranslationService.get('common.from')}:</th>
                <td>{tripLeg.origin.stopPoint.name}</td>
              </tr>
              <tr>
                <th scope="row">{TranslationService.get('common.to')}:</th>
                <td>{tripLeg.destination.stopPoint.name}</td>
              </tr>
              <tr>
                <th scope="row">{TranslationService.get('common.when')}:</th>
                <td>
                  <span className="text-preserve-spaces">{createWhenString(tripLeg.plannedDepartureTime, tripLeg.plannedArrivalTime)}</span>
                </td>
              </tr>
            </>
          )}
        </tbody>
      </table>
      <div className="text-end">
        <button className="btn--as-link" aria-controls={`${id}-form`} onClick={onEditButtonClick}>
          {TranslationService.get('common.edit')}
        </button>
      </div>
    </div>
  );
}

export default Summary;
